import React from "react";
import uuidv4 from "uuid/v4";
import CustomChip from "../../../general/chips";

const QuickChips = ({filterChips, setFilterChips, setUuidCurrentFilter}) => {

  return (
    <div className="chipsContainer">
      {
        filterChips.map((el, key) => {
          return (
            <CustomChip
              style={{ margin: "5px 24px 0 0", cursor: "pointer" }}
              key={`filterChip_${el.key}`}
              active={filterChips[key].active}
              className={filterChips[key].active ? "active" : ""}
              onClick={() => {
                setUuidCurrentFilter(uuidv4());
                const cloneFilterChips = [...filterChips];
                cloneFilterChips[key].active = !cloneFilterChips[key].active;              
                setFilterChips(cloneFilterChips);
              }}
              description={el.desc}
            />
          );
        })
      }
    </div>
  );
};

export default QuickChips;